import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './number-card-info.scss';
import NumberCardInfoBody from './number-card-info-body';

export default function NumberCardInfo({
  direction,
  value,
  mode,
  title,
  modes,
  multiple,
  ...props
}) {
  let timeout;
  const [active, setActive] = useState(false);
  const [leftPosition, setLeftPosition] = useState();
  const [topPosition, setTopPosition] = useState();
  const [userInfoHeight, setUserInfoHeight] = useState(0);
  const [userInfoWidth, setUseInfoWidth] = useState(0);
  const userInfoContainer = useRef(null);

  useEffect(() => {
    setUserInfoHeight(userInfoContainer?.current?.clientHeight);
    setUseInfoWidth(userInfoContainer?.current?.clientWidth);
  });

  const showUserInfo = (e) => {
    if (direction === 'right') {
      timeout = setTimeout(() => {
        const rectangle = e.target?.getBoundingClientRect();
        if (rectangle.x + rectangle.width + userInfoWidth > window.innerWidth) {
          setLeftPosition(rectangle.x - userInfoWidth);
        } else {
          setLeftPosition(rectangle.x + rectangle.width + 2);
        }
        if (
          rectangle.y + rectangle.height + userInfoHeight >
          window.innerHeight
        ) {
          setTopPosition(rectangle.y - userInfoHeight);
        } else {
          setTopPosition(rectangle.y - rectangle.height);
        }

        setActive(true);
      }, 200);
    } else if (direction === 'left') {
      setTimeout(() => {
        const rectangle = e.target?.getBoundingClientRect();
        setLeftPosition(rectangle.x - userInfoWidth);
        setTopPosition(rectangle.y - rectangle.height);
        setActive(true);
      }, 200);
    } else {
      setTimeout(() => {
        const rectangle = e.target?.getBoundingClientRect();
        if (rectangle.x + rectangle.width + userInfoWidth > window.innerWidth) {
          setLeftPosition(rectangle.x - userInfoWidth);
        } else {
          setLeftPosition(rectangle.x + rectangle.width - 10);
        }
        if (
          rectangle.y + rectangle.height + userInfoHeight >
          window.innerHeight
        ) {
          setTopPosition(rectangle.y - userInfoHeight);
        } else {
          setTopPosition(rectangle.y - rectangle.height);
        }
        setActive(true);
      }, 200);
    }
  };
  const showInfo = () => {
    setActive(true);
  };
  const hideUserInfo = () => {
    clearInterval(timeout);
    setTimeout(() => {
      setActive(false);
    }, 200);
  };

  return (
    <div
      className="number-card-info-wrapper"
      onMouseEnter={showUserInfo}
      onMouseLeave={hideUserInfo}
    >
      {props.children}
      <NumberCardInfoBody
        active={active}
        left={leftPosition}
        top={topPosition}
        ref={userInfoContainer}
        mouseEnter={showInfo}
        mouseLeave={hideUserInfo}
        value={value}
        mode={mode}
        title={title}
        modes={modes}
        multiple={multiple}
      />
    </div>
  );
}

NumberCardInfo.propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.string,
  value: PropTypes.number,
  mode: PropTypes.string,
  title: PropTypes.string,
  modes: PropTypes.instanceOf(Object),
  multiple: PropTypes.bool,
};
NumberCardInfo.defaultProps = {
  direction: '',
  value: 0,
  mode: '',
  title: '',
  modes: {},
  multiple: false,
};
